import { useState } from "react"

export const VariableProducts =() => {
    const [state, setState] = useState({
        name: '',
        material_category_id: "",
        material_category_name: "",
        material_sub_category_id: "",
        material_sub_category_name :"",
        warehouse_id: "",
        warehouse_name: "",
        type: "",
        brand: "",
        model: "",
        sn: "",
        notes: "",
        status: 'active',
        description:'',
        director_name: "",
        productioner_name: "",
        open: false,
        openEdit: false,
        arr1: [],
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenEdit = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,
    setLoad
  }
}
